import { getDefaultStore } from 'jotai';
import { objectAtomFamily } from '@/jotai/atom';
import { atomKeys } from '@/jotai/atom-keys';
import { Config } from '@/utils/config';

// FEAT-085: a tab that missed the room's lock learns from the server's refusal instead, so the
// builder hides its editing controls after the first refused write.
export async function lockIfDocumentSigned(response: Response) {
  if (response.status !== 403) return;

  const payload = (await response
    .clone()
    .json()
    .catch(() => null)) as { details?: { code?: string } } | null;
  if (payload?.details?.code !== Config.SIGNED_DOCUMENT_ERROR_CODE) return;

  const projectInfoAtom = objectAtomFamily(atomKeys.projectInfo);
  const store = getDefaultStore();
  const projectInfo = store.get(projectInfoAtom) as ProjectInfo | undefined;
  if (projectInfo?.is_signed) return;
  store.set(projectInfoAtom, { ...projectInfo, is_signed: true });
}
